export default {"src":"/_next/static/media/Information.d92b497a.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};